import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-[#0a0a0a] text-white">
      {/* Main Footer Content */}
      <div className="px-4 md:px-8 lg:px-32 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12 lg:gap-16">
          {/* Newsletter Section */}
          <div>
            <h3 className="text-2xl md:text-3xl font-light mb-4 md:mb-6">{t('footer.newsletter.title')}</h3>
            <p className="text-sm md:text-base text-gray-400 mb-4 md:mb-6">{t('footer.newsletter.description')}</p>
            <div className="flex flex-col sm:flex-row gap-3">
              <input
                type="email"
                placeholder={t('footer.newsletter.placeholder')}
                className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-sm md:text-base text-white placeholder-gray-500 focus:outline-none focus:border-white/40 transition-colors"
              />
              <button className="px-6 py-3 bg-white text-[#0a0a0a] rounded-lg hover:bg-gray-200 transition-colors cursor-pointer whitespace-nowrap text-sm md:text-base">
                {t('footer.newsletter.submit')}
              </button>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs md:text-sm uppercase tracking-wider text-gray-500 mb-4 md:mb-6">{t('footer.quickLinks.title')}</h4>
            <div className="space-y-2 md:space-y-3">
              <Link to="/about" className="block text-sm md:text-base text-white hover:text-gray-300 transition-colors cursor-pointer">
                {t('nav.about')}
              </Link>
              <Link to="/hybrid-workforce" className="block text-sm md:text-base text-white hover:text-gray-300 transition-colors cursor-pointer">
                {t('nav.hybrid')}
              </Link>
              <Link to="/businesses" className="block text-sm md:text-base text-white hover:text-gray-300 transition-colors cursor-pointer">
                {t('nav.businesses')}
              </Link>
              <Link to="/solutions" className="block text-sm md:text-base text-white hover:text-gray-300 transition-colors cursor-pointer">
                {t('nav.solutions')}
              </Link>
            </div>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-xs md:text-sm uppercase tracking-wider text-gray-500 mb-4 md:mb-6">{t('footer.contact.title')}</h4>
            <div className="space-y-2 md:space-y-3 text-sm md:text-base text-gray-400">
              <p className="leading-relaxed">
                {t('footer.contact.address')}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10 px-4 md:px-8 lg:px-32 py-4 md:py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          {/* Social Links */}
          <div className="flex items-center gap-6 order-2 md:order-1">
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-lg md:text-xl"></i>
            </a>
            <a href="#" className="text-white hover:text-gray-300 transition-colors cursor-pointer">
              <i className="ri-twitter-x-fill text-lg md:text-xl"></i>
            </a>
          </div>

          {/* Copyright */}
          <div className="text-xs md:text-sm text-gray-500 order-1 md:order-2">
            © 2025 BrainCommerce. {t('footer.rights')}
          </div>

          {/* Legal Links */}
          <div className="flex items-center gap-4 md:gap-6 text-xs md:text-sm order-3">
            <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">
              {t('footer.terms')}
            </a>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
